
import Vue from "vue";
import LogoSquareIcon from "@/components/icons/LogoSquareIcon.vue";

export default Vue.extend({
  name: "LoadingIndicator",
  components: { LogoSquareIcon },
});
